// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","dashboardContainer":"_2rCY3","containerLeft":"_2qcLl","lastPressReleasesContainer":"_2bkop"};